import { render, staticRenderFns } from "./FileSystemContextMenu.vue?vue&type=template&id=4cdac087&"
import script from "./FileSystemContextMenu.vue?vue&type=script&lang=ts&"
export * from "./FileSystemContextMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports